import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import ReactDropzone from 'react-dropzone';

import { Icons, Text, Wrapper } from 'widget/components';
import { useWidgetContext } from 'widget/widget-context';

import Icon from './icon/icon';

interface Dropzone {
  fileName?: string;
  isImage?: boolean;
  multiple?: boolean;
  onChange: (file: File[]) => void;
  placeholder?: string;
}

const Dropzone = ({
  fileName,
  isImage,
  multiple = false,
  onChange,
  placeholder,
}: Dropzone) => {
  const { widget } = useWidgetContext();
  const { t } = useTranslation();

  const htmlPlaceholder = placeholder ?? t`Upload a file`;

  return (
    <ReactDropzone
      accept={isImage ? { 'image/*': [] } : undefined}
      multiple={multiple}
      onDrop={acceptedFiles => onChange(acceptedFiles)}
    >
      {({ getInputProps, getRootProps, isDragAccept }) => (
        <div
          {...getRootProps()}
          className={cn('whatcrm-widget-dropzone', {
            'whatcrm-widget-dropzone_active': isDragAccept,
          })}
        >
          <input {...getInputProps()} />
          <Icon />

          <Wrapper alignItems="center" gap={8} justifyContent="center">
            <Text
              color={widget.theme == 'light' ? 'primary' : undefined}
              isEllipsis
            >
              {fileName ?? htmlPlaceholder}
            </Text>

            <Icons.Paperclip
              fill={widget.theme == 'dark' ? 'white' : undefined}
              size={20}
            />
          </Wrapper>
        </div>
      )}
    </ReactDropzone>
  );
};

export default Dropzone;
